/** Readable file names for downloads: `projeto_referencia_20260927-1432.mp4` instead of the storage UUID. */

function slug(text: string, max = 40): string {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, max)
    .replace(/-+$/g, '');
}

function stamp(at: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${at.getFullYear()}${p(at.getMonth() + 1)}${p(at.getDate())}-${p(at.getHours())}${p(at.getMinutes())}`;
}

function extensionOf(url: string, fallback: string): string {
  const m = /\.([a-z0-9]{2,4})(?:[?#]|$)/i.exec(url);
  return (m?.[1] || fallback).toLowerCase();
}

export function friendlyFileName(opts: {
  project?: string;
  reference?: string;
  url: string;
  at?: Date | number;
  fallbackExt?: string;
}): string {
  const parts = [slug(opts.project || '') || 'seu-video', slug(opts.reference || '')].filter(Boolean);
  const at = opts.at ? new Date(opts.at) : new Date();
  return `${parts.join('_')}_${stamp(Number.isNaN(at.getTime()) ? new Date() : at)}.${extensionOf(opts.url, opts.fallbackExt || 'mp4')}`;
}

/** Saves `url` under `filename`; cross-origin URLs are fetched first so the name sticks. */
export async function downloadMedia(url: string, filename: string): Promise<void> {
  const save = (href: string) => {
    const a = document.createElement('a');
    a.href = href;
    a.download = filename;
    a.rel = 'noopener';
    document.body.appendChild(a);
    a.click();
    a.remove();
  };
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(String(res.status));
    const href = URL.createObjectURL(await res.blob());
    save(href);
    window.setTimeout(() => URL.revokeObjectURL(href), 30_000);
  } catch {
    window.open(url, '_blank', 'noopener');
  }
}
